module.exports = __webpack_public_path__ + "static/media/leopard_head_orientation_left copy.c30cd650.jpeg";